import { Storefront } from '@phosphor-icons/react';

/**
 * The single PRO badge used everywhere a professional seller is shown.
 * Style is copied verbatim from the original `ListingCard` listing-thumb
 * badge (light blue surface, store icon, pill, tiny weight) — DO NOT
 * fork or restyle. Three preset sizes that match the surfaces we render
 * on:
 *
 *   • thumb   — 9px text, used INSIDE the listing-card image overlay
 *               (matches the legacy listing badge exactly).
 *   • inline  — 10px text, default size for sitting next to a seller
 *               name on listing-detail / profile / message header.
 *   • mini    — 9px text, slightly tighter padding for chat-row use
 *               cases that need to fit alongside a tiny avatar.
 *
 * `data-testid="pro-badge"` is preserved across every surface so the
 * existing tests continue to find it.
 */
const SIZE_CLASSES = {
  thumb:  'gap-0.5 px-1.5 py-0.5 text-[9px]',
  inline: 'gap-1 px-2 py-0.5 text-[10px]',
  mini:   'gap-0.5 px-1.5 py-0 text-[9px]',
};
const ICON_PX = { thumb: 9, inline: 10, mini: 9 };

export const ProBadge = ({ size = 'inline', className = '', title }) => {
  const sz = SIZE_CLASSES[size] || SIZE_CLASSES.inline;
  return (
    <span
      className={`inline-flex items-center rounded-full font-bold bg-info-soft text-info border border-info/10 ${sz} ${className}`}
      data-testid="pro-badge"
      title={title}
    >
      <Storefront size={ICON_PX[size] || 10} weight="fill" /> PRO
    </span>
  );
};
